const OhSusanna = [
	'[VERSE 1]',
	'Oh I come from Alabama with a banjo on my knee,',
	"I'm going to Louisiana, my true love for to see",
	'It rained all night the day I left, the weather it was dry',
	"The sun so hot I froze to death; Susanna, don't you cry.",
	'',
	'[CHORUS]',
	"Oh, Susanna, don't you cry for me",
	'For I come from Alabama,',
	'with my banjo on my knee.',
	'',
	'[VERSE 2]',
	'I had a dream the other night when everything was still,',
	'I thought I saw Susanna coming up the hill,',
	'The buckwheat cake was in her mouth, the tear was in her eye,',
	"I said I'm coming from Dixieland, Susanna don't you cry.",
	'',
	'[CHORUS]',
	"Oh, Susanna, don't you cry for me",
	'For I come from Alabama,',
	'with my banjo on my knee.',
	'',
	'[VERSE 3]',
	"I soon will be in New Orleans, and then I'll look around",
	"And when I find my gal Susanne, I'll fall upon the ground.",
	"But if I do not find her, this darkey'll surely die,",
	"and when I'm dead and buried, Susanna don't you cry.",
	'',
	'[CHORUS]',
	"Oh, Susanna, don't you cry for me",
	'For I come from Alabama,',
	'with my banjo on my knee.',
];

export default OhSusanna;
